import { Module } from "vuex";
import { TimelineMilestone } from "@/models/applicationStatus";
import { $api } from "@/services/api";

export function getStep(id: number, steps: TimelineMilestone[]) {
  return steps.find(step => step.id === id);
}

export function getStepIndex(id: number, steps: TimelineMilestone[]) {
  return steps.findIndex(step => step.id === id);
}

const applicationStatusModule: Module<any, any> = {
  namespaced: true,
  state: {
    timeline: [] as TimelineMilestone[],
    currentStep: undefined as undefined | TimelineMilestone,
    currentStepNumber: 1 as number,
    maximumStep: 1 as number,
    selectedStep: 1 as number,
  },
  mutations: {
    SET_SELECTED_STEP(state: any, step: number) {
      state.selectedStep = step;
    },
    SET_MAXIMUM_STEP(state: any, maximum: number) {
      state.maximumStep = maximum;
    },
    SET_TIMELINE(state: any, steps: TimelineMilestone[]) {
      state.timeline = steps;
    },
    SET_CURRENT_STEP(state: any, step: TimelineMilestone) {
      state.currentStep = step;
    },
  },
  actions: {
    setCurrentStepNumber({ commit }, step: number) {
      commit("SET_CURRENT_STEP_NUMBER", step);
    },
    setSelectedStep({ commit }, step: number) {
      commit("SET_SELECTED_STEP", step);
    },
    async getTimelineAsync({ commit }, payload: { applicationId: number; applicantId: number }) {
      const { applicationId, applicantId } = payload;

      const timelineResponse = await $api.applications.getApplicationTimelineAsync(
        applicationId,
        applicantId,
      );
      if (timelineResponse.results && timelineResponse.success) {
        commit("SET_TIMELINE", timelineResponse.results?.milestoneSteps);
        commit("SET_CURRENT_STEP", timelineResponse.results?.currentStep);
        commit("SET_MAXIMUM_STEP", timelineResponse.results?.maximumStep);
        commit("SET_SELECTED_STEP", timelineResponse.results.currentStep?.step || 1);
      }
      console.log("timeline", timelineResponse);
    },
  },
};

export default applicationStatusModule;
